// waits for wistia's video to be 1 second in before revealing (prevents flicker bug)

export default function (wistia) {
	return new Promise((resolve) => {
		const onWistiaBufferComplete = () => {
			wistia.unbind('timechange', onWistiaBufferComplete);
			resolve();
		};

		wistia.bind('timechange', onWistiaBufferComplete);
	});
}
